"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.addressOptions = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _ui = require("@unite-us/ui");
var _addresses = _interopRequireDefault(require("../../utils/addresses"));
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var addressOptions = exports.addressOptions = function addressOptions(contact) {
  return [].concat(_toConsumableArray(contact && _lodash["default"].get(contact, 'addresses[0]', null) ? [{
    label: 'Client Address',
    value: 'client'
  }] : []), [{
    label: 'Our Address',
    value: 'ours'
  }, {
    label: 'Other',
    value: 'other'
  }]);
};
var getAddressOptions = function getAddressOptions(results) {
  var options = _lodash["default"].map(results, function (result) {
    return {
      address: result.formatted_address,
      id: result.place_id,
      latLng: {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng()
      }
    };
  });
  return options;
};
var getAddressFromType = function getAddressFromType(type, groupAddress, contactAddress) {
  switch (type) {
    case _constants.ADDRESS_TYPES.ours:
      return _addresses["default"].getFormattedAddress(groupAddress);
    case _constants.ADDRESS_TYPES.client:
      return _addresses["default"].getFormattedAddress(contactAddress);
    default:
      return '';
  }
};
var GeoFilter = /*#__PURE__*/function (_Component) {
  _inherits(GeoFilter, _Component);
  var _super = _createSuper(GeoFilter);
  function GeoFilter(props) {
    var _this;
    _classCallCheck(this, GeoFilter);
    _this = _super.call(this, props);
    _this.applyFilters = _this.applyFilters.bind(_assertThisInitialized(_this));
    _this.setAddress = _this.setAddress.bind(_assertThisInitialized(_this));
    _this.setAddressSelect = _this.setAddressSelect.bind(_assertThisInitialized(_this));
    _this.setAddressType = _this.setAddressType.bind(_assertThisInitialized(_this));
    _this.setDistance = _this.setDistance.bind(_assertThisInitialized(_this));
    _this.geoCode = _this.geoCode.bind(_assertThisInitialized(_this));
    _this.getGeoCodeOptions = _this.getGeoCodeOptions.bind(_assertThisInitialized(_this));
    _this.getDebouncedGeoCodeOptions = _lodash["default"].debounce(_this.getGeoCodeOptions, 400);
    _this.setOptions = _this.setOptions.bind(_assertThisInitialized(_this));
    var filters = props.filters,
      currentUserGroup = props.currentUserGroup,
      contact = props.contact,
      multipleLocationsEnabled = props.multipleLocationsEnabled,
      providerFilterLocations = props.providerFilterLocations;
    var contactAddress = _addresses["default"].findHomeOrFirstAddress(_lodash["default"].get(contact, 'addresses', []));
    var groupAddress = _lodash["default"].get(currentUserGroup, 'addresses[0]');
    var address = !_lodash["default"].isEmpty(filters.address) ? filters.address : getAddressFromType(filters.addressType, groupAddress, contactAddress);
    var locationOptions = [_addresses["default"].getFormattedAddress(groupAddress)];
    if (multipleLocationsEnabled) {
      var formattedLocations = [].concat(_toConsumableArray(locationOptions), _toConsumableArray(_addresses["default"].getFormattedLocations(providerFilterLocations)));
      locationOptions = _lodash["default"].uniqBy(formattedLocations, 'address');
    }
    _this.state = {
      address: address,
      addressType: filters.addressType || '',
      distance: filters.distance || 'any',
      locationOptions: locationOptions
    };
    return _this;
  }
  _createClass(GeoFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state = this.state,
        address = _this$state.address,
        addressType = _this$state.addressType;
      // Force a geocode if we're dealing with a client address. Sometimes
      // client addresses do not have a lat/long already associated w/ the data.
      if (addressType === _constants.ADDRESS_TYPES.client || _constants.ADDRESS_TYPES.ours) {
        this.geoCode({
          address: address,
          addressType: addressType
        });
      }
      this.setAddressSelect(address);
      this.applyFilters();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var incomingFilters = {
        address: nextProps.filters.address,
        addressType: nextProps.filters.addressType,
        distance: nextProps.filters.distance || 'any'
      };
      if (!_lodash["default"].isEqual(this.state.address, nextProps.filters.address)) {
        var newAddress = nextProps.filters.address;
        this.setAddressSelect(newAddress);
      }
      if (!_lodash["default"].isEqual(this.props, nextProps) && !_lodash["default"].isEqual(incomingFilters, this.state) && !_lodash["default"].isEmpty(incomingFilters)) {
        this.setState(_objectSpread({}, incomingFilters), function () {
          return _this2.applyFilters();
        });
      }
    }
  }, {
    key: "setAddressSelect",
    value: function setAddressSelect(address) {
      var _this$props = this.props,
        multipleLocationsEnabled = _this$props.multipleLocationsEnabled,
        contact = _this$props.contact;
      var _this$state2 = this.state,
        addressType = _this$state2.addressType,
        locationOptions = _this$state2.locationOptions;
      if (this.addressSelectField) {
        var clientAddressData = _addresses["default"].findHomeOrFirstAddress(_lodash["default"].get(contact, 'addresses', []));
        var clientAddress = _addresses["default"].getFormattedAddress(clientAddressData);
        var type = addressType.value ? addressType.value : addressType;
        var options;
        if (type === _constants.ADDRESS_TYPES.client) {
          options = [clientAddress];
        } else if (type === _constants.ADDRESS_TYPES.ours) {
          options = locationOptions;
        } else {
          options = [address];
        }
        this.addressSelectField.setOptions({
          options: multipleLocationsEnabled ? options : [address],
          replace: true
        });
        this.addressSelectField.setValue(address);
      }
    }
  }, {
    key: "setDistance",
    value: function setDistance(value) {
      var _this3 = this;
      this.setState({
        distance: value
      }, function () {
        return _this3.applyFilters();
      });
    }
  }, {
    key: "setAddressType",
    value: function setAddressType(addressType) {
      var _this4 = this;
      var _this$props2 = this.props,
        currentUserGroup = _this$props2.currentUserGroup,
        contact = _this$props2.contact;
      var contactAddress = _addresses["default"].findHomeOrFirstAddress(_lodash["default"].get(contact, 'addresses', []));
      var groupAddress = _lodash["default"].get(currentUserGroup, 'addresses[0]');
      var type = addressType.value;
      var address = getAddressFromType(type, groupAddress, contactAddress);
      if (this.addressSelectField) {
        this.setAddressSelect(address);
      }
      if (type === _constants.ADDRESS_TYPES.client && contactAddress && !_lodash["default"].isEmpty(address) || type === _constants.ADDRESS_TYPES.ours && !_lodash["default"].isEmpty(address)) {
        this.geoCode({
          address: address,
          addressType: addressType
        });
      } else {
        this.setState({
          address: address,
          addressType: addressType
        }, function () {
          return _this4.applyFilters();
        });
      }
    }
  }, {
    key: "setAddress",
    value: function setAddress() {
      var _this5 = this;
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props3 = this.props,
        currentUserGroup = _this$props3.currentUserGroup,
        contact = _this$props3.contact,
        multipleLocationsEnabled = _this$props3.multipleLocationsEnabled;
      var clientAddress = _addresses["default"].findHomeOrFirstAddress(_lodash["default"].get(contact, 'addresses', []));
      var groupAddress = _lodash["default"].get(currentUserGroup, 'addresses[0]');
      var groupClientLocations = _lodash["default"].without([_addresses["default"].getFormattedAddress(clientAddress)].concat(_toConsumableArray(this.state.locationOptions)), '');
      var notGroupOrClientAddress = multipleLocationsEnabled ? !groupClientLocations.map(function (l) {
        return l.latLng;
      }).includes(address.latLng) : address.address !== _addresses["default"].getAddressString(groupAddress) || address !== _addresses["default"].getAddressString(clientAddress);
      this.setState({
        address: address,
        addressType: notGroupOrClientAddress ? {
          label: 'Other',
          value: 'other'
        } : this.state.addressType
      }, function () {
        return _this5.applyFilters();
      });
    }
  }, {
    key: "getGeoCodeOptions",
    value: function getGeoCodeOptions(address, callback) {
      if (address.length > 3) {
        var google = this.props.google;
        var geoCoder = new google.maps.Geocoder();
        geoCoder.geocode({
          address: address
        }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            var options = getAddressOptions(results);
            callback({
              options: options
            });
          } else {
            /* eslint-disable-next-line no-console */
            console.warn("Geocode was not successful for the following reason: ".concat(status));
          }
        });
      } else {
        callback({
          options: []
        });
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions() {
      var _this$state3 = this.state,
        address = _this$state3.address,
        addressType = _this$state3.addressType,
        contact = _this$state3.contact,
        locationOptions = _this$state3.locationOptions;
      var contactAddress = _addresses["default"].findHomeOrFirstAddress(_lodash["default"].get(contact, 'addresses', []));
      var type = addressType.value ? addressType.value : addressType;
      var options;
      if (type === _constants.ADDRESS_TYPES.client) {
        options = [contactAddress];
      } else if (type === _constants.ADDRESS_TYPES.ours) {
        options = locationOptions;
      } else {
        options = [address];
      }
      return options;
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.props.onFiltersChange(this.state);
      this.props.setGeoFilters(this.state);
    }
  }, {
    key: "geoCode",
    value: function geoCode(_ref) {
      var _this6 = this;
      var _ref$address = _ref.address,
        address = _ref$address === void 0 ? {} : _ref$address,
        _ref$addressType = _ref.addressType,
        addressType = _ref$addressType === void 0 ? '' : _ref$addressType;
      if (!_lodash["default"].isEmpty(address)) {
        var google = this.props.google;
        var geoCoder = new google.maps.Geocoder();
        geoCoder.geocode({
          address: address.address
        }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK && !_lodash["default"].isEmpty(results)) {
            var addressWithUSA = results[0].formatted_address;
            var geoCodedAddress = {
              address: addressWithUSA.slice(0, addressWithUSA.length - 5),
              id: !_lodash["default"].isEmpty(address.id) ? address.id : results[0].place_id,
              latLng: {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng()
              }
            };
            _this6.setState({
              address: geoCodedAddress,
              addressType: addressType
            }, function () {
              return _this6.applyFilters();
            });
          } else {
            _this6.setState({
              address: '',
              addressType: addressType
            }, function () {
              return _this6.applyFilters();
            });
            /* eslint-disable-next-line no-console */
            console.warn("Geocode was not successful for the following reason: ".concat(status));
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$props4 = this.props,
        contact = _this$props4.contact,
        label = _this$props4.label;
      var _this$state4 = this.state,
        distance = _this$state4.distance,
        addressType = _this$state4.addressType,
        locationOptions = _this$state4.locationOptions;
      var type = addressType.value ? addressType.value : addressType;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-filter-section ui-geo-filter"
      }, /*#__PURE__*/_react["default"].createElement("h5", {
        className: "ui-filter-section__label"
      }, label), /*#__PURE__*/_react["default"].createElement(_ui.SelectField, {
        id: "ui-distance-filter",
        className: "ui-geo-filter__distance-select ui-geo-filter__filter",
        label: "Distance Select",
        field: {
          onBlur: _lodash["default"].noop,
          onChange: this.setDistance,
          value: distance
        },
        options: _constants.DISTANCE_OPTIONS,
        placeholder: "Distance",
        searchEnabled: false,
        shouldSort: false,
        hideLabel: true
      }), /*#__PURE__*/_react["default"].createElement(_ui.SelectField, {
        className: "ui-geo-filter__address-type-select ui-geo-filter__filter",
        field: {
          onBlur: _lodash["default"].noop,
          onChange: this.setAddressType,
          value: addressType
        },
        forceObjectValue: true,
        hideLabel: true,
        id: "uiaddress-type-filter",
        label: "Address Type Select",
        placeholder: "Address Type",
        options: addressOptions(contact),
        searchEnabled: false,
        shouldSort: false
      }), /*#__PURE__*/_react["default"].createElement(_ui.SelectField, {
        className: "ui-geo-filter__address-select ui-geo-filter__filter",
        field: {
          onBlur: _lodash["default"].noop,
          onChange: this.setAddress
        },
        filterOptions: function filterOptions(options) {
          return options;
        },
        options: type === _constants.ADDRESS_TYPES.ours ? locationOptions : this.setOptions,
        hideLabel: true,
        id: "ui-searched-addresses-filter",
        label: "Address",
        labelKey: "address",
        loadOptions: type === _constants.ADDRESS_TYPES.other ? this.getDebouncedGeoCodeOptions : null,
        name: "search-addresses",
        placeholder: "Search for an Address",
        ref: function ref(c) {
          _this7.addressSelectField = c;
        },
        valueKey: "id"
      }));
    }
  }]);
  return GeoFilter;
}(_react.Component);
GeoFilter.propTypes = {
  /** optional contact object */
  contact: _propTypes["default"].object,
  /** current group from the session */
  currentUserGroup: _propTypes["default"].object.isRequired,
  /** current filters */
  filters: _propTypes["default"].shape({
    address: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
    addressType: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
    distance: _propTypes["default"].string
  }).isRequired,
  /** label for the filter section */
  label: _propTypes["default"].string.isRequired,
  /**
   * @param {object} activeFilters object of selected filters
   * @public
  */
  multipleLocationsEnabled: _propTypes["default"].bool,
  onFiltersChange: _propTypes["default"].func.isRequired,
  /**
   * @param {object} activeFilters object of selected filters
   * @public
  */
  providerFilterLocations: _propTypes["default"].array,
  setGeoFilters: _propTypes["default"].func,
  /** the google maps api object */
  google: _propTypes["default"].object.isRequired
};
GeoFilter.defaultProps = {
  contact: {},
  multipleLocationsEnabled: false,
  providerFilterLocations: [],
  setGeoFilters: _lodash["default"].noop
};
var _default = exports["default"] = GeoFilter;